'use strict';

var isBefore = require('date-fns/isBefore');
var startOfDay = require('date-fns/startOfDay');

function _interopDefault (e) { return e && e.__esModule ? e.default : e; }

var isBefore__default = /*#__PURE__*/_interopDefault(isBefore);
var startOfDay__default = /*#__PURE__*/_interopDefault(startOfDay);

function isBeforeDay(...params) {
  return isBefore__default(startOfDay__default(params[0]), startOfDay__default(params[1]));
}

exports.isBeforeDay = isBeforeDay;
//# sourceMappingURL=isBeforeDay.cjs.map
